import axios, { AxiosError, AxiosResponse } from "axios";

import { checkResponseStatusAndLogOut } from "../api/checkResponseStatusAndLogOut";
import { httpErrorHandlerService } from "./http-error-handler-service";
import { DEFAULT_ERROR_RESPONSE } from "../constants";
import { HTTPResponse, QueryModel } from "../models";
import { combineQuery } from "../helpers";

export const http = axios.create({
  withCredentials: true,
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Content-type": "application/json",
  },
  paramsSerializer: {
    serialize: (params: QueryModel) => {
      return combineQuery(params).slice(1);
    },
  },
});

const onFulfilled = (res: AxiosResponse<HTTPResponse<any>>) => res.data.result;

const onRejected = (error: AxiosError) => {
  if (error?.response?.status === 401) {
    checkResponseStatusAndLogOut();
  }
  httpErrorHandlerService.handle(error);
  throw error.response?.data || DEFAULT_ERROR_RESPONSE;
  return error.response?.data || DEFAULT_ERROR_RESPONSE;
};

http.interceptors.response.use(onFulfilled, onRejected);
